import React from "react";
import Dropdown, { DropdownOption } from "./Dropdown"; // Adjust the import path based on your project structure

interface LanguageDropdownProps {
  value: DropdownOption | null;
  onChange: (value: DropdownOption | null) => void;
  placeholder?: string;
  className?: string;
}

export const LANGUGAGE_OPTIONS: DropdownOption[] = [
  { name: "English", code: "EN" },
  { name: "German", code: "DE" },
];

const LanguageDropdown: React.FC<LanguageDropdownProps> = ({
  value,
  onChange,
  placeholder = "Select a language",
  className,
}) => {
  return (
    <Dropdown
      options={LANGUGAGE_OPTIONS}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      className={className}
    />
  );
};

export default LanguageDropdown;
